import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
import IconBack from '@white-label-icon/icon-back';

// @ts-expect-error Check how we can import useNuxtApp without type warning

export default /*#__PURE__*/_defineComponent({
  __name: 'back-button',
  props: {
    isLogout: {
      type: Boolean
    },
    buttonText: {
      default: 'back'
    }
  },
  emits: ["btnClick"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var nuxtApp = useNuxtApp();
    var backButtonText = computed(function () {
      var _nuxtApp$$t, _nuxtApp$$t2;
      var text = "UI.buttons.".concat(props.buttonText);
      return (_nuxtApp$$t = (_nuxtApp$$t2 = nuxtApp.$t) === null || _nuxtApp$$t2 === void 0 ? void 0 : _nuxtApp$$t2.call(nuxtApp, text)) !== null && _nuxtApp$$t !== void 0 ? _nuxtApp$$t : text;
    });
    return {
      __sfc: true,
      nuxtApp: nuxtApp,
      emit: emit,
      props: props,
      backButtonText: backButtonText,
      IconBack: IconBack
    };
  }
});